
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "export-api"
    }}>{`Export API`}</h1>
    <p>{`The general approach is:`}</p>
    <ul>
      <li parentName="ul">{`Consumer specifies the scope of data to be exported (details below).`}</li>
      <li parentName="ul">{`The API if successful, will return the stream in the format specified.`}</li>
      <li parentName="ul">{`Error will be returned on failure of the call.`}</li>
    </ul>
    <p>{`See `}<a parentName="p" {...{
        "href": "#/ExportHDFSAPI"
      }}>{`here`}</a>{` for details on exporting `}<em parentName="p">{`hdfs_path`}</em>{` entities.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Title`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Export API`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Example`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See Examples sections below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`api/atlas/admin/export`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Method`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`POST`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`URL Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`None`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Data Parameters`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The class `}<em parentName="td">{`AtlasExportRequest`}</em>{` is used to specify the items to export. The list of `}<em parentName="td">{`AtlasObjectId`}</em>{`(s) allows for specifying the multiple items to export in a session. The `}<em parentName="td">{`AtlasObjectId`}</em>{` is a tuple of entity type, name of unique attribute, value of unique attribute. Several items can be specified. See examples below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Success Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`File stream as `}<em parentName="td">{`application/zip`}</em>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Error Response`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors that are handled within the system will be returned as `}<em parentName="td">{`AtlasBaseException`}</em>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Notes`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Consumer could choose to consume the output of the API by programmatically using `}<em parentName="td">{`java.io.ByteOutputStream`}</em>{` or by manually, save the contents of the stream to a file on the disk.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Method Signature`}</strong></p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`@POST
@Path("/export")
@Consumes("application/json;charset=UTF-8")`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "additional-options"
    }}>{`Additional Options`}</h3>
    <p>{`It is possible to specify additional parameters for the `}<em parentName="p">{`Export`}</em>{` operation.`}</p>
    <p>{`The current implementation has 2 options. Both are optional:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`matchType`}</em>{` This option configures the approach used for fetching the starting entity. It has the following values:`}
        <ul parentName="li">
          <li parentName="ul"><em parentName="li">{`startsWith`}</em>{` Search for an entity that is prefixed with the specified criteria.`}</li>
          <li parentName="ul"><em parentName="li">{`endsWith`}</em>{` Search for an entity that is suffixed with the specified criteria.`}</li>
          <li parentName="ul"><em parentName="li">{`contains`}</em>{` Search for an entity that has the specified criteria as a sub-string.`}</li>
          <li parentName="ul"><em parentName="li">{`matches`}</em>{` Search for an entity that is a regular expression match with the specified criteria.`}</li>
        </ul>
      </li>
    </ul>
    <ul>
      <li parentName="ul"><em parentName="li">{`fetchType`}</em>{` This option configures the approach used for fetching entities. It has the following values:`}
        <ul parentName="li">
          <li parentName="ul"><em parentName="li">{`FULL`}</em>{`: This fetches all the entities that are connected directly and indirectly to the starting entity. E.g. If a starting entity specified is a table, then this option will fetch the table, database and all the other tables within the database.`}</li>
          <li parentName="ul"><em parentName="li">{`CONNECTED`}</em>{`: This fetches all the entities that are connected directly to the starting entity. E.g. If a starting entity specified is a table, then this option will fetch the table and the database entity only.`}</li>
          <li parentName="ul"><em parentName="li">{`INCREMENTAL`}</em>{`: See `}<a parentName="li" {...{
              "href": "#/IncrementalExport"
            }}>{`here`}</a>{` for details.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`If no `}<em parentName="p">{`matchType`}</em>{` is specified, an exact match is used. Which means, that the entire string is used in the search criteria.`}</p>
    <p>{`Searching using `}<em parentName="p">{`matchType`}</em>{` applies to all types of entities. It is particularly useful for matching entities of type hdfs_path (see `}<a parentName="p" {...{
        "href": "#/ExportHDFSAPI"
      }}>{`here`}</a>{`).`}</p>
    <p>{`The `}<em parentName="p">{`fetchType`}</em>{` option defaults to `}<em parentName="p">{`FULL`}</em>{`.`}</p>
    <p>{`For a complete example see the section below.`}</p>
    <h3 {...{
      "id": "contents-of-exported-zip-file"
    }}>{`Contents of Exported ZIP File`}</h3>
    <p>{`The exported ZIP file has the following entries within it:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`atlas-export-result.json`}</em>{`:`}
        <ul parentName="li">
          <li parentName="ul">{`Input filters: The scope of export.`}</li>
          <li parentName="ul">{`File format: The format chosen for the export operation.`}</li>
          <li parentName="ul">{`Metrics: The number of entity definitions, classifications and entities exported.`}</li>
        </ul>
      </li>
      <li parentName="ul"><em parentName="li">{`atlas-typesdef.json`}</em>{`: Type definitions for the entities exported.`}</li>
      <li parentName="ul"><em parentName="li">{`atlas-export-order.json`}</em>{`: Order in which entities should be exported.`}</li>
      <li parentName="ul"><em parentName="li">{`{guid}.json`}</em>{`: Individual entities are exported with file names that correspond to their id.`}</li>
    </ul>
    <h3 {...{
      "id": "examples"
    }}>{`Examples`}</h3>
    <p>{`The `}<em parentName="p">{`AtlasExportRequest`}</em>{` below shows filters that attempt to export 2 databases in cluster cl1:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "itemsToExport": [
       { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "accounts@cl1" } },
       { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "hr@cl1" } }
    ]
}`}
    </SyntaxHighlighter>
    <p>{`The `}<em parentName="p">{`AtlasExportRequest`}</em>{` below specifies the `}<em parentName="p">{`fetchType`}</em>{` as `}<em parentName="p">{`FULL`}</em>{`. The `}<em parentName="p">{`matchType`}</em>{` option will fetch `}<em parentName="p">{`accounts@cl1`}</em>{`.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "itemsToExport": [
       { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "accounts@" } }
    ],
    "options": {
        "fetchType": "FULL",
        "matchType": "startsWith"
    }
}`}
    </SyntaxHighlighter>
    <p>{`The `}<em parentName="p">{`AtlasExportRequest`}</em>{` below specifies the `}<em parentName="p">{`guid`}</em>{` instead of `}<em parentName="p">{`uniqueAttributes`}</em>{` to fetch `}<em parentName="p">{`accounts@cl1`}</em>{`.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "itemsToExport": [
       { "typeName": "hive_db", "guid": "846c5e9c-3ac6-40ju-8289-fb0cebm64783" }
    ],
    "options": {
        "fetchType": "FULL",
    }
}`}
    </SyntaxHighlighter>
    <p>{`The `}<em parentName="p">{`AtlasExportRequest`}</em>{` below specifies the `}<em parentName="p">{`fetchType`}</em>{` as `}<em parentName="p">{`connected`}</em>{`. The `}<em parentName="p">{`matchType`}</em>{` option will fetch `}<em parentName="p">{`accountsReceivable`}</em>{`, `}<em parentName="p">{`accountsPayable`}</em>{`, etc. present in the database.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "itemsToExport": [
       { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "accounts" } }
    ],
    "options": {
        "fetchType": "CONNECTED",
        "matchType": "startsWith"
    }
}`}
    </SyntaxHighlighter>
    <p>{`Below is the `}<em parentName="p">{`AtlasExportResult`}</em>{` JSON for the export of the `}<em parentName="p">{`Sales`}</em>{` DB present in the `}<em parentName="p">{`QuickStart`}</em>{`.`}</p>
    <p>{`The `}<em parentName="p">{`metrics`}</em>{` contains the number of types and entities exported as part of the operation.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "clientIpAddress": "10.0.2.15",
    "hostName": "10.0.2.2",
    "metrics": {
        "duration": 1415,
        "entitiesWithExtInfo": 12,
        "entity:DB_v1": 2,
        "entity:LoadProcess_v1": 2,
        "entity:Table_v1": 6,
        "entity:View_v1": 2,
        "typedef:Column_v1": 1,
        "typedef:DB_v1": 1,
        "typedef:LoadProcess_v1": 1,
        "typedef:StorageDesc_v1": 1,
        "typedef:Table_v1": 1,
        "typedef:View_v1": 1,
        "typedef:classification": 6
    },
    "operationStatus": "SUCCESS",
    "request": {
        "itemsToExport": [
            {
                "typeName": "DB_v1",
                "uniqueAttributes": {
                    "name": "Sales"
                }
            }
        ],
        "options": {
            "fetchType": "full"
        }
    },
    "userName": "admin"
}`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "curl-calls"
    }}>{`CURL Calls`}</h3>
    <p>{`Below are sample CURL calls that demonstrate Export of `}<em parentName="p">{`QuickStart`}</em>{` database.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -X POST -u adminuser:password -H "Content-Type: application/json" -H "Cache-Control: no-cache" -d '{
    "itemsToExport": [
            { "typeName": "DB", "uniqueAttributes": { "name": "Sales" }},
            { "typeName": "DB", "uniqueAttributes": { "name": "Reporting" }},
            { "typeName": "DB", "uniqueAttributes": { "name": "Logging" }}
    ],
        "options": { "fetchType": "full" }
    }' "http://localhost:21000/api/atlas/admin/export" > quickStartDB.zip`}
    </SyntaxHighlighter>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;